import { IVo, VisionVO, WizConstants, entity, field } from '@wizeoo/akm-compute-lib';
import { TranslatedEmb, VisionLinesStat, VisionStat, VisionStep, VisionValuesStat } from '@wizeoo/akm-message-lib';
import { BasicEntityVO } from '../core/basic-entity.vo';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';
import { Model } from '../../model/model';
import { VISION_PROPERTY } from '../../model/enums';


/** capsule utilisée uniquement côté IHM pour faciliter les rendus */
@entity('wizeoo.allkeyme.vision.message.VisionStep', 'VISION')
export class VisionStepVO extends BasicEntityVO<VisionStep> implements IVo {

  constructor(pSource?: VisionStep) {
    super(pSource);
  }

  public get code(): string {
    return this.source.code;
  }
  public set code(pValue: string) {
    this.source.code = pValue;
  }

  public get visionCode(): string {
    return this.source.visionCode;
  }
  public set visionCode(pValue: string) {
    this.source.visionCode = pValue;
  }

  public get level(): number {
    return this.source.level;
  }
  public set level(pValue: number) {
    this.source.level = pValue;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

    /*
     * Return translated label
     * @return string
     */
  get trsLabel(): string {
      return Model.getInstance().localeEngine.translate(this.label, this.code);
  }

  /** accesseur sur le libellé composite code vision + code step */
  public get visionAndStep(): string {
    return this.source.visionCode + WizConstants.KEY_SEPARATOR + this.code;
  }

  /** accesseur sur le libellé composite level + label pour drop des mesures */
  public get levelAndLabel(): string {
    return this.source.level + ' - ' + this.trsLabel;
  }

  public get nbLines(): number {
    let res: number = null;

    let vision: VisionVO = Model.getInstance().visionEngine.getVision(this.source.visionCode);
    // console.log('vision', vision);

    let stats: VisionStat = Model.getInstance().visionEngine.getVisionProperties(vision, VISION_PROPERTY.METRICS);
    stats?.lines?.forEach((vls: VisionLinesStat) => {
      if(vls.stepLevel === this.level) {
        res = vls.nbLines;
      }
    });

    return res;
  }

  public get nbValues(): number {
    let res: number = null;

    let vision: VisionVO = Model.getInstance().visionEngine.getVision(this.source.visionCode);
    //  console.log('vision', vision);

    let stats: VisionStat = Model.getInstance().visionEngine.getVisionProperties(vision, VISION_PROPERTY.METRICS);
    stats.values.forEach((vls: VisionValuesStat) => {
      if(vls.stepLevel === this.level) {
        res = vls.nbLines;
      }
    });

    return res;
  }

}
